export default __webpack_public_path__ + "static/media/sbo-girl.16ed7b34.webp";